import axios from "axios";
import * as mediator from "@tvg/mediator-classic/src";
import _ from "lodash";
import ServiceUrl from "../../factories/serviceUrl"; // eslint-disable-line
import {
  successRequest,
  failRequest,
  successNoResults
} from "../../actions/LHNRequestActions";
import lhnQuery from "./lhnTracksQuery";
import Poller from "../Poller/Poller";

const LHNInterval = 30000;
const STATUS_ORDER = ["SK", "IC", "O"];
const LHNPoller = new Poller();

const sortByStatus = (raceList) =>
  _.sortBy(raceList, [
    (race) => {
      const statusCode = race.raceStatus.code;
      const orderStatus = STATUS_ORDER.indexOf(statusCode);
      const orderStatusValue =
        orderStatus >= 0 ? orderStatus : STATUS_ORDER.length;

      return race.mtp === 0 ? orderStatusValue : race.mtp + STATUS_ORDER.length;
    }
  ]);

const getImportanceLevel = (level) => (level === "Normal" ? "0" : "1");

const mapRaces = (races = []) =>
  races.map((race) => {
    const tempRace = {
      country: _.get(race, "location.country", ""),
      isGreyhound: race.isGreyhound,
      mtp: race.mtp,
      perfAbbr: _.get(race, "track.perfAbbr", ""),
      postTime: race.postTime,
      raceId: race.id,
      raceNumber: race.number,
      raceStatus: race.status,
      trackAbbr: _.get(race, "track.code", ""),
      trackName: _.get(race, "track.name", ""),
      typeCode: _.get(race, "type.code", ""),
      onTvg: _.get(race, "video.onTvg", false),
      onTvg2: _.get(race, "video.onTvg2", false)
    };

    if (_.get(race, "highlighted")) {
      tempRace.importanceLevel = getImportanceLevel(
        _.get(race, "highlighted.style", null)
      );
      tempRace.description = _.get(race, "highlighted.description", null);
      tempRace.action = _.get(race, "highlighted.action", null);
      tempRace.pinnedOrder = _.get(race, "highlighted.pinnedOrder", null);
    }

    return tempRace;
  });

const extractRacesFromTracks = (tracks = []) => {
  const races = tracks.reduce(
    (result, track) => result.concat(track.races),
    []
  );
  return mapRaces(races);
};

const sortFeatureRaces = (raceList) =>
  _.sortBy(raceList, ["pinnedOrder", "postTime"]);

const calcBrand = (wagerProfile) => {
  switch (wagerProfile) {
    case "PORT-NJ":
      return "4NJBets";
    case "PORT-PA":
      return "PABets";
    case "PORT-IA":
      return "IA";
    default:
      return "TVG";
  }
};

function handleResponse(response) {
  if (!response.data) {
    return response;
  }

  const highlightedRaces = _.get(response, "data.data.lhnFeatureRaces") || [];

  const leftBarData = {
    leftBarRaces: extractRacesFromTracks(
      _.get(response, "data.data.lhnTracks")
    ),
    featuredRaces: mapRaces(highlightedRaces.filter((race) => race.highlighted))
  };

  if (
    leftBarData.leftBarRaces.length === 0 &&
    leftBarData.featuredRaces.length === 0
  ) {
    return successNoResults();
  }

  leftBarData.leftBarRaces = sortByStatus(leftBarData.leftBarRaces);
  leftBarData.featuredRaces = sortFeatureRaces(leftBarData.featuredRaces);

  return successRequest(leftBarData);
}

const getHighlightedData = (wagerProfile) => ({
  brand: calcBrand(wagerProfile),
  product: "TVG4",
  device: "Desktop"
});

const requestOptions = (
  profile = "PORT-Generic",
  favoritesTracks = [],
  withGreyhounds = true,
  breedsFilters = [],
  racesCategoryFilters
) => {
  const trackFilter =
    racesCategoryFilters === "FAV"
      ? {
          code: favoritesTracks,
          allTrackClasses: withGreyhounds
        }
      : {
          allTrackClasses: withGreyhounds
        };
  const raceFilter =
    breedsFilters.length > 0
      ? {
          status: ["MO", "O", "IC"],
          typeCode: breedsFilters,
          allRaceClasses: withGreyhounds
        }
      : {
          status: ["MO", "O", "IC"],
          allRaceClasses: withGreyhounds
        };
  const highlightedData = getHighlightedData(profile);
  return {
    url: `${ServiceUrl.getServiceUrl("service.cosmo")}`,
    method: "POST",
    withCredentials: true,
    data: {
      operationName: "getLhnInfo",
      query: lhnQuery,
      variables: {
        wagerProfile: profile,
        trackFilter,
        raceFilter,
        product: highlightedData.product,
        device: highlightedData.device,
        brand: highlightedData.brand,
        breedsFilter: breedsFilters,
        withGreyhounds
      }
    }
  };
};

const makeRequest = (
  dispatch,
  profile,
  favoritesTracks,
  withGreyhounds,
  breedsFilters,
  racesCategoryFilters
) => {
  const options = requestOptions(
    profile,
    favoritesTracks,
    withGreyhounds,
    breedsFilters,
    racesCategoryFilters
  );
  axios(options)
    .then((response) => {
      dispatch(handleResponse(response));
    })
    .catch((err) => {
      dispatch(failRequest(err));
    })
    .then(() => {
      mediator.dispatch("FILTERS_LOADING_FINISHED", {});
    });
};

const startPoller = (
  dispatch,
  profile,
  favoritesTracks,
  withGreyhounds,
  breedsFilters,
  racesCategoryFilters
) =>
  LHNPoller.start(
    () =>
      makeRequest(
        dispatch,
        profile,
        favoritesTracks,
        withGreyhounds,
        breedsFilters,
        racesCategoryFilters
      ),
    LHNInterval
  );
const stopPoller = () => LHNPoller.stop();
const refreshPoller = (
  dispatch,
  profile,
  favoritesTracks,
  withGreyhounds,
  breedsFilters,
  racesCategoryFilters
) =>
  LHNPoller.refresh(
    () =>
      makeRequest(
        dispatch,
        profile,
        favoritesTracks,
        withGreyhounds,
        breedsFilters,
        racesCategoryFilters
      ),
    LHNInterval
  );

export default {
  makeRequest,
  startPoller,
  stopPoller,
  refreshPoller
};
